import type { DeliveryState } from "@veto/protocol";

function Check({ double = false, className = "" }: { double?: boolean; className?: string }) {
  return (
    <svg className={className} width={double ? 16 : 12} height={12} viewBox={double ? "0 0 16 12" : "0 0 12 12"} aria-hidden>
      <path
        d="M1.5 6.5 4.2 9.2 10.5 2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {double && (
        <path
          d="M5.5 6.5 7.2 8.2 13.5 2.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}

/** SPEC §6.4 message visual states */
export function DeliveryTicks({ state }: { state: DeliveryState }) {
  if (state === "queued" || state === "draft") {
    return (
      <span className="ticks ticks-pending" aria-label="Queued">
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden>
          <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.5" fill="none" />
          <path d="M6 3.5V6l1.8 1.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </span>
    );
  }
  if (state === "sent") {
    return (
      <span className="ticks" aria-label="Sent">
        <Check />
      </span>
    );
  }
  if (state === "backed_up") {
    return (
      <span className="ticks" aria-label="Backed up">
        <Check double />
      </span>
    );
  }
  if (state === "delivered") {
    return (
      <span className="ticks ticks-delivered" aria-label="Delivered">
        <Check double />
      </span>
    );
  }
  if (state === "read") {
    return (
      <span className="ticks ticks-read" aria-label="Read">
        <Check double />
      </span>
    );
  }
  if (state === "attention" || state === "failed") {
    return (
      <span className="ticks ticks-warn" aria-label="Attention required">
        !
      </span>
    );
  }
  return null;
}
